import { render } from "./IconDelete.vue?vue&type=template&id=e1420aaa"
import script from "./IconDelete.vue?vue&type=script&lang=js"
export * from "./IconDelete.vue?vue&type=script&lang=js"

import exportComponent from "D:\\LTG Sercices\\SUP-H\\suph-adhesion-non-pro\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__